import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use((response) => response,
    (error) => {
        const status = error.response?.status
        const location = error.response?.headers['location'];
        if (status === 401 && !!location) {
            window.location.href = location;
        } else {
            return Promise.reject(error);
        }
    });
